import { combineReducers } from 'redux';
import { AuthReducer, IAuthState as AuthState } from '../reducers/authReducer';
import { IAnalyticalState, analyticalReducer } from './analyticalPBFReducer';
import { IAPICommercialListState, apiCommercialReducer } from './apiCommercialReducer';
import { IAPIDevToolingState, apiDevelopmentToolingReducer } from './apiDevelopmentToolingReducer';
import { IAPIKSMState, apiKSMReducer } from './apiKSMReducer';
import { IAPIState, apiReducer } from './apiReducer';
import { IBeRLDCostState, beRLDCostRducer } from './beRLDCostReducer';
import { IcogsEstimationListState, cogsEstimationReducer } from './cogsEstimationReducer';
import { IcommercialListState, commercialReducer } from './commercialReducer';
import { ICurrencyDateFormatDetails, currencydateFormatReducer } from './currencydateFormatReducer';
import { IDocumentsUploadState, documentsUploadReducer } from './documentsUploadReducer';
import { IExipientPMState, excpPmReducer } from './excipientPmReduser';
import { IFilingCostState, filingCostReducer } from './filingCostReducer';
import { IFinalApprovalState, finalApprovalReducer } from './finalApprovalReducer';
import { IFinalPLEvaluationState, finalPLEvaluationReducer } from './finalPLEvaluationReducer';
import { IFinalScheduleState, finalScheduleReducer } from './finalScheduleReducer';
import { IFormulationDevState, formulationDevReducer } from './formulationDevReducer';
import { InLicensedListState, inLicenseReducer } from './inLicensedReducer';
import { IIPDListState, ipdReducer } from './ipdReducer';
import { IAPIKSMRequirementState, ksmRequirementReducer } from './ksmRequirementReducer';
import { IManpowerState, manpowerReducer } from './manpowerReducer';
import { IOtherMaterialState, otherMaterialReducer } from './otherMaterialReduser';
import { IPidfState, PidfReducer } from './pidfReducer';
import { IProjectInitiationState, projectInitiationReducer } from './projectInitiationReducer';
import { reportsReducer } from './reportsReducer';
import { IRevenueState, revenueReducer } from './revenueReducer';
import { IToolingPlantCostState, ToolingPlantCostReducer } from './toolingPlantCostReducer';
import { IUserManagementListState, userManagementReducer } from './userManagementReducer';
interface RootStateType {
    readonly auth: AuthState | undefined | unknown;
    readonly pidf: IPidfState | undefined | unknown;
    readonly projectInitiation: IProjectInitiationState | undefined | unknown;
    readonly projectCommercials: IcommercialListState | undefined | unknown;
    readonly apiCommercials: IAPICommercialListState | undefined | unknown;
    readonly projectIPD: IIPDListState | undefined | unknown;
    readonly formulationDevelopment: IFormulationDevState | undefined | unknown;
    readonly apiTab: IAPIState | undefined | unknown;
    readonly excipientPM: IExipientPMState | undefined | unknown;
    readonly analytical: IAnalyticalState | undefined | unknown;
    readonly toolingPlantCost: IToolingPlantCostState | undefined | unknown;
    readonly beRLDCost: IBeRLDCostState | undefined | unknown;
    readonly manpowerCost: IManpowerState | undefined | unknown;
    readonly InLicensed: InLicensedListState | undefined | unknown;
    readonly apiKSM: IAPIKSMState | undefined | unknown;
    readonly userManagement: IUserManagementListState | undefined | unknown;
    readonly ksmRequirement: IAPIKSMRequirementState | undefined | unknown;
    readonly otherMaterials: IOtherMaterialState | undefined | unknown;
    readonly apiDevTooling: IAPIDevToolingState | undefined | unknown;
    readonly filingCost: IFilingCostState | undefined | unknown;
    readonly reports: any | undefined | unknown;
    readonly finalSchedule: IFinalScheduleState | undefined | unknown;
    readonly finalPLEvaluation: IFinalPLEvaluationState | undefined | unknown;
    readonly finalApproval: IFinalApprovalState | undefined | unknown;
    readonly uploadDocuments: IDocumentsUploadState | undefined | unknown;
    readonly revenue: IRevenueState | undefined | unknown;
    readonly currencydateFormatDetails: ICurrencyDateFormatDetails | undefined | unknown;
    readonly cogsEstimation: IcogsEstimationListState | undefined | unknown;
}

// eslint-disable-next-line import/no-anonymous-default-export
const rootReducer: any = combineReducers<RootStateType>({
    auth: AuthReducer,
    pidf: PidfReducer,
    projectInitiation: projectInitiationReducer,
    projectCommercials: commercialReducer,
    apiCommercials: apiCommercialReducer,
    projectIPD: ipdReducer,
    formulationDevelopment: formulationDevReducer,
    apiTab: apiReducer,
    excipientPM: excpPmReducer,
    analytical: analyticalReducer,
    toolingPlantCost: ToolingPlantCostReducer,
    beRLDCost: beRLDCostRducer,
    manpowerCost: manpowerReducer,
    InLicensed: inLicenseReducer,
    userManagement: userManagementReducer,
    apiKSM: apiKSMReducer,
    ksmRequirement: ksmRequirementReducer,
    otherMaterials: otherMaterialReducer,
    apiDevTooling: apiDevelopmentToolingReducer,
    filingCost: filingCostReducer,
    reports: reportsReducer,
    finalSchedule: finalScheduleReducer,
    finalPLEvaluation: finalPLEvaluationReducer,
    finalApproval: finalApprovalReducer,
    revenue: revenueReducer,
    currencydateFormatDetails: currencydateFormatReducer,
    cogsEstimation: cogsEstimationReducer,
    uploadDocuments : documentsUploadReducer
});

export default rootReducer;